/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AccessListService } from '../../services/access-list.service';
import { AccessListItem } from './invite-user.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/internal/Subscription';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.less'],
  standalone: false,
})
export class EditRoleComponent implements OnInit, OnDestroy {
  @Input() accessListUsers: AccessListItem[];

  roles: RoleType[] = [
    { isChecked: true, value: 'User', display: 'SDE_USER' },
    { isChecked: false, value: 'Manager', display: 'SDE_MANAGER' },
  ];

  selectedRole: RoleType = this.roles[0];
  processing = false;
  refreshSub: Subscription;

  constructor(
    private accessListService: AccessListService,
    public activeModal: NgbActiveModal,
    private errorService: ErrorService,
  ) {}

  ngOnInit() {
    this.refreshSub = this.accessListService.refreshAccessListSuccess.subscribe(
      () => {
        this.activeModal.dismiss();
        this.processing = false;
      },
    );
    // Set the selected role to 'Manager' if a single user is being edited and their current role is 'Manager'.
    if (
      this.accessListUsers.length == 1 &&
      this.accessListUsers[0].accessListRole == 'Manager'
    ) {
      this.selectedRole = this.roles[1];
    }
  }

  onToggle(role: RoleType) {
    this.selectedRole = role;
  }

  async save() {
    this.processing = true;
    Promise.all(
      this.accessListUsers.map(async (user) => {
        try {
          user.accessListRole = this.selectedRole.value;
          await this.accessListService.addToAccessList(user);
        } catch (error) {
          console.log(`error editing user: ${user.userId}`);
          this.errorService.displayGeneralError().result.then(() => {
            this.activeModal.dismiss();
          });
        }
      }),
    ).then(() => {
      this.accessListService.emitRefreshEvent();
    });
  }

  ngOnDestroy() {
    this.refreshSub.unsubscribe();
  }
}

export interface RoleType {
  isChecked: boolean;
  value: string;
  display: string;
}
